import React, {Component} from "react";
import {Container, Row, Col, Card, CardImg, Table} from 'reactstrap'
import {
    MDBContainer,
    MDBRow,
    MDBCol, MDBBtn, MDBBreadcrumb, MDBBreadcrumbItem
} from "mdbreact"
import CommunityPostList from "./CommunityPostList/CommunityPostList";
import classes from './CommunityPage.module.css'
import firebase from "../../../Config/firebase";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {isAuth} from "../../../Utils/firebaseUtils";
import common from "../../../Utils/common.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Jdenticon from "react-jdenticon";
import {faArrowLeft, faScroll, faVoteYea} from "@fortawesome/free-solid-svg-icons";
import CommunityReport from "../CommunityReport/CommunityReport";

const db =firebase.firestore()

class CommunityPage extends Component{
    constructor(props) {
        super(props);
        this.state = {
            // community: {},
            // isLoaded: false,
            // isSubscribed: false
        }
    }

    // componentDidMount() {
    //     if(typeof this.props.location.state !== "undefined"){
    //         if(this.props.location.state.hasOwnProperty('community')){
    //             this.setState({
    //                 community: this.props.location.state.community
    //             },()=>{
    //                 this.setState({
    //                     isLoaded:true
    //                 })
    //             })
    //         }
    //     }else{
    //         this.getCommunityFromFirebase(this.props.match.params.cid)
    //     }
    // }
    //
    //  getCommunityFromFirebase = (cid) => {
    //     this.setState({
    //         isLoaded :false
    //     } ,() => {
    //         db.collection('Community').doc(cid)
    //             .get()
    //             .then(doc =>{
    //                 if(doc.exists){
    //                     this.setState({
    //                         community: doc.data()
    //                     }, () => {
    //                         this.setState({
    //                             isLoaded:true
    //                         })
    //                     })
    //                 }
    //             })
    //             .catch(err=>console.log(err))
    //     })
    //
    // }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if(this.props.location.pathname !== nextProps.location.pathname){
    //         if(typeof nextProps.location.state !== "undefined"){
    //             if(nextProps.location.state.hasOwnProperty('community')){
    //                 this.setState({
    //                     community: nextProps.location.state.community
    //                 },()=>{
    //                     this.setState({
    //                         isLoaded:true
    //                     })
    //                 })
    //             }
    //         }else{
    //             this.getCommunityFromFirebase(nextProps.match.params.cid)
    //         }
    //     }
    // }

    // subscribe = (id) => {
    //     db.collection('Member')
    //         .doc(this.props.auth.uid)
    //         .update({
    //             subscribedList: firebase.firestore.FieldValue.arrayUnion(id)
    //         })
    //         .then(res => {
    //             this.setState({
    //                 isSubscribed: true
    //             })
    //         })
    //         .catch(err => console.log(err))
    // }

    render() {
        // if (this.state.isLoaded) {
            return (
                <MDBContainer>
                    {/*<MDBRow>*/}
                    {/*    <MDBCol xs='4' sm='4' md='4' lg='4' xl='2'>*/}
                    {/*        <div className={classes.ImageContainer}>*/}
                    {/*            {typeof this.state.community.avatar !== 'undefined' && this.state.community.avatar !== '' ?*/}
                    {/*                <img src={this.state.community.avatar} alt={this.state.community.titleCHI}*/}
                    {/*                     className={classes.Avatar}/>*/}
                    {/*                :*/}
                    {/*                <Jdenticon size="100" value={this.state.community.id}/>*/}
                    {/*            }*/}
                    {/*        </div>*/}
                    {/*    </MDBCol>*/}
                    {/*    <MDBCol xs='4' sm='4' md='4' lg='4' xl='8'>*/}
                    {/*        <MDBRow>*/}
                    {/*            <MDBCol>*/}
                    {/*                <h2>*/}
                    {/*                    {this.state.community.titleCHI}*/}
                    {/*                </h2>*/}
                    {/*            </MDBCol>*/}
                    {/*        </MDBRow>*/}
                    {/*    </MDBCol>*/}
                    {/*    <MDBCol xs='4' sm='4' md='4' lg='4' xl='2'>*/}
                    {/*        <div className={classes.SubscribeBtn}>*/}
                    {/*            {*/}
                    {/*                isAuth(this.props.auth) ?*/}
                    {/*                    <MDBBtn color={this.state.isSubscribed ? 'danger' : 'secondary'}*/}
                    {/*                            onClick={() => this.subscribe(this.state.community.id)}*/}
                    {/*                    >*/}
                    {/*                        {this.state.isSubscribed ? "取消訂閱" : "訂閱"}*/}
                    {/*                    </MDBBtn>*/}
                    {/*                    :*/}
                    {/*                    <MDBBtn color="info">*/}
                    {/*                        請先登入*/}
                    {/*                    </MDBBtn>*/}
                    {/*            }*/}

                    {/*        </div>*/}
                    {/*    </MDBCol>*/}
                    {/*</MDBRow>*/}
                    <MDBRow>
                        <MDBCol xs='12' sm='12' md='12' lg='12' xl='12'>
                            {/*<div className={classes.FeatureContainer}>*/}
                                   <CommunityReport/>

                            {/*</div>*/}
                            <div className={classes.FeatureContainer}>
                                <h5>
                                    <FontAwesomeIcon icon={faVoteYea}/>資料搜集
                                </h5>
                                <div className={classes.FeatureComponent} >
                                    <a href='https://cuhk.au1.qualtrics.com/jfe/form/SV_4T8kdxcMYlKKf7T' className={classes.FeatureText}>
                                        <h6><FontAwesomeIcon icon={faScroll}/>《疫情停課下的老師》</h6>
                                        本問卷調查由「明師 Teacher Mingler」發起。我們相信，快樂的學生，由....
                                    </a>
                                </div>


                            </div>
                            {/*<Table bordered>*/}
                            {/*    <thead>*/}
                            {/*    <tr>*/}
                            {/*        <th>種類</th>*/}
                            {/*        <th>校網</th>*/}
                            {/*        <th>組別</th>*/}
                            {/*        <th>語言</th>*/}
                            {/*        <th>性別</th>*/}
                            {/*        <th>宗教</th>*/}
                            {/*    </tr>*/}
                            {/*    </thead>*/}
                            {/*    <tbody>*/}
                            {/*    <tr>*/}
                            {/*        <th scope="row">官立</th>*/}
                            {/*        <td>北區</td>*/}
                            {/*        <td>2C</td>*/}
                            {/*        <td>中中</td>*/}
                            {/*        <td>男女</td>*/}
                            {/*        <td>天主教</td>*/}
                            {/*    </tr>*/}
                            {/*    </tbody>*/}
                            {/*</Table>*/}
                        </MDBCol>
                    </MDBRow>
                    <hr className={classes.Hrstyle}/>
                    <Link to={{pathname:'/new-post',
                        state:{communityID: this.props.match.params.cid}}}>
                        <MDBBtn color='primary' rounded > New Post</MDBBtn>
                    </Link>
                    <CommunityPostList data={this.state.community}/>
                </MDBContainer>
            )
        // }
        // else{
        //     return(
        //         <div>
        //             loading...
        //         </div>
        //     )
        // }

    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(CommunityPage))